var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6714 2C18.3103 2 22.8812 6.477 22.8812 12C22.8812 17.523 18.3103 22 12.6714 22C7.03256 22 2.46164 17.523 2.46164 12C2.46164 6.477 7.03256 2 12.6714 2ZM12.6612 10H11.6505C11.3902 10.0003 11.1399 10.0979 10.9507 10.2728C10.7615 10.4478 10.6476 10.687 10.6324 10.9414C10.6171 11.1958 10.7016 11.4464 10.8687 11.6418C11.0357 11.8373 11.2726 11.9629 11.531 11.993L11.6505 12V16.99C11.6505 17.51 12.0527 17.94 12.5693 17.994L12.6816 18H13.1819C13.3966 18 13.6059 17.9337 13.7799 17.8105C13.954 17.6873 14.0839 17.5135 14.1513 17.3139C14.2187 17.1142 14.2201 16.8988 14.1553 16.6982C14.0905 16.4977 13.9628 16.3223 13.7904 16.197L13.6924 16.134V11.01C13.6924 10.49 13.2901 10.06 12.7735 10.006L12.6612 10ZM12.6714 7C12.4006 7 12.141 7.10536 11.9495 7.29289C11.758 7.48043 11.6505 7.73478 11.6505 8C11.6505 8.26522 11.758 8.51957 11.9495 8.70711C12.141 8.89464 12.4006 9 12.6714 9C12.9422 9 13.2019 8.89464 13.3934 8.70711C13.5848 8.51957 13.6924 8.26522 13.6924 8C13.6924 7.73478 13.5848 7.48043 13.3934 7.29289C13.2019 7.10536 12.9422 7 12.6714 7Z",
    fill: "#C2DD91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreen);
export default __webpack_public_path__ + "static/media/info-green.ed32a6971502a3de05f3c9cfb788f48e.svg";
export { ForwardRef as ReactComponent };